/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { format } from 'date-fns'

import { IColumn } from 'types'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'

export const useTableModel = () => {
  const { t } = useTranslation()

  const handleAuthorFormat = useCallback(
    (cellValue: string, row: any) => row.author?.title,
    [],
  )

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any) => <MainTableActionButtons row={row} baseUrl={'/assignments/'} />,
    [],
  )

  const handleDateFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'dd-MM-yyyy') : ''),
    [],
  )

  const columns: IColumn[] = [
    {
      title: `${t('common.status')}`,
      field: 'status',
      order: true,
      width: '10%',
    },
    {
      title: `${t('common.title')}`,
      field: 'title',
      order: true,
      width: '25%',
    },
    {
      title: `${t('common.assessment-type')}`,
      field: 'assessment_type',
      order: true,
      width: '15%',
    },
    {
      title: `${t('common.submission-type')}`,
      field: 'submission_type',
      order: true,
      width: '15%',
    },
    {
      title: `${t('common.author')}`,
      field: 'author',
      width: '20%',
      order: true,
      format: handleAuthorFormat,
    },
    {
      title: `${t('common.due-date')}`,
      field: 'due_datetime',
      width: '10%',
      order: true,
      format: handleDateFormat,
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}
